import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { NovaIconRegistry } from '@rds-nova/angular-icon';
import { ChatButtonOpenComponent } from '../chat-button-open/chat-button-open.component';
import { ChatWindowComponent } from '../chat-window/chat-window.component';
import { ChatConversationStore } from './chat-conversation.store';
import { FaqAdapter } from 'src/app/features/help-faq/services/faq.adapter';
import { ChatUiService } from 'src/app/features/help-faq/services/chat-ui.service';
import { AppState } from 'src/app/store';
import { selectSigningId } from 'src/app/features/session/store/selectors/session.selectors';

@Component({
    selector: 'app-chat-widget',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ChatConversationStore, FaqAdapter],
    imports: [
        NovaIconRegistry,
        ChatButtonOpenComponent,
        ChatWindowComponent,
    ],
    template: `
    <nova-icon-registry></nova-icon-registry>

    @if (store.widgetState() === 'opened') {
      <app-chat-window
        chipsDirection = 'column'
        [items]="store.items()"
        [chips]="store.chips()"
        [rootChips]="store.rootChips()"
        [selectedRootChipId]="store.selectedRootNodeId()"
        [chipsDisabled]="store.isLoading()"
        (chipClick)="store.selectChip($event)"
        (minimize)="store.minimize()"
        (closed)="store.close()"
      ></app-chat-window>
    }

    @if(chatUi.currentView() === 'DEFAULT') {
      @if (store.widgetState() !== 'opened') {
        <app-chat-button-open
          state="default"
          [type]="store.widgetState() === 'minimized' ? 'minimized' : 'default'"
          (activate)="store.open()"
        ></app-chat-button-open>
      }
    }
  `,
    styleUrl: './chat-widget.component.scss',
})
export class ChatWidgetComponent {
  protected store = inject(ChatConversationStore);
  protected faqAdapter = inject(FaqAdapter);
  private readonly appStore = inject(Store<AppState>);
  private readonly signingId = this.appStore.selectSignal(selectSigningId);
  readonly chatUi = inject(ChatUiService);
  private previousOpenRequests = 0;

  constructor() {
    effect(() => {
      if (this.store.widgetState() === 'opened') {
        const id = this.signingId();
        if (id && !this.faqAdapter.hasData()) {
          void this.faqAdapter.load(id);
        }
      }
    });

    effect(() => {
      const requests = this.chatUi.openRequests();
      if (requests > this.previousOpenRequests) {
        this.previousOpenRequests = requests;
        this.store.open();
      }
    });
  }
}
